module.exports = {
  postPublish: "Publié le ",
  postRelatedPosts: "Ces articles pourraient aussi *vous intéresser.*",

  "404Title": "Page non trouvée",
  "404Subtitle":
    "Veuillez vérifier l'URL dans la barre d'adresse et réessayer.",
  "404Button": "Retournez à l'accueil",

  nlEmailField: "Adresse email",
  nlSubmit: "Envoyer ",
}
